import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { InputTextarea } from "primereact/inputtextarea";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { InputNumber } from "primereact/inputnumber";
import { AuthContext } from "../../../../Header/auth - context";
import { Column } from "primereact/column";
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import CustomDropdown from "../../../../custom/customDropdown";
import handlePrintReceiverDispacher from '../Nova_prijemnica/novaPrijemnicaOtpremnicaStampa';
import "primeicons/primeicons.css";
import ConfirmationModalPrijemnicaOtpremnica from "../../../../custom/ConfirmationModalPrijemnicaOtpremnica";
import BarcodeScanner from '../Nova_prijemnica/BarcodeScanner';
import GumaScanDijalog from '../Nova_prijemnica/GumaScanDijalog';
import ConfirmationModalArticles from "../../../../custom/ConfirmationModalArticles";
import UnosArtiklaKonfig from "../Artical/Unos_artikla_konfig";

const Nova_otpremnica = (props) => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const toast = useRef(null);
  const formRef = useRef(null);
  const formRefItems = useRef(null);
  
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formSubmittedItems, setFormSubmittedItems] = useState(false);

  const [confirmVisible, setConfirmVisible] = useState(false); 
  const [confirmVisibleArticles, setConfirmVisibleArticles] = useState(false); 
  

  const [klijentiOptions, setKlijentiOptions] = useState([]);
  const [magacinOptions, setMagacinOptions] = useState([]);
  const [statisiOptions, setStatisiOptions] = useState([]);
  const [tipoviOptions, setTipoviOptions] = useState([]);
  const [vozilaOptions, setVozilaOptions] = useState([]);
  /* Interni vozaci — spisak se koristi samo kad je tip otpreme INTERNO. */
  const [vozaciOptions, setVozaciOptions] = useState([]);
  
  const [jedinicaMereOptions, setJedinicaMereOptions] = useState([]);

  const [idDispacher, setIdDispacher] = useState(null);
  /* Sifarnik valuta stize uz ostale opcije magacina. */
  const [valutaOpcije, setValutaOpcije] = useState([]);
  const valutaOznaka = (id) => valutaOpcije.find(v => Number(v.value) === Number(id))?.label || '';
  const history = useHistory();
  /* Faktura nastala iz ove otpremnice (procedura je vraca uz zaglavlje). */
  const [fakturaInfo, setFakturaInfo] = useState(null);
  const [idItem, setIdItem] = useState(null);


  //Stavke
  const [nazivArtiklaOptions, setNazivArtiklaOptions] = useState([]);
  const [zalihaOptions,     setZalihaOptions]     = useState([]);
  const [gumaZalihaOptions, setGumaZalihaOptions] = useState([]);
  const [filterGuma, setFilterGuma] = useState(false);
  const [scannerVisible, setScannerVisible]         = useState(false);
  const [gumaDijalogVisible, setGumaDijalogVisible] = useState(false);
  const [scannedCode, setScannedCode]               = useState(null);
  const [gumaExisting, setGumaExisting]             = useState(null);
  const [persistMagacin, setPersistMagacin]         = useState(null);
  const [scannerKey, setScannerKey]                 = useState(0);
  const [izabran, setIzabran] = useState(false);
  const [popuni, setPopuni] = useState(false);
  const [gumaCart, setGumaCart] = useState([]);
  const [serBrojOptions, setSerBrojOptions] = useState([]);
  const [selectedGumaId, setSelectedGumaId] = useState(null);

  const [allColumns, setAllColumns] = useState([]);
  const isSelected = (row) => String(getId(row)) === String(selectedRowId);
  const [selectedRowId , setSelectedRowId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  /* Broj stavki po strani bira korisnik; petnaest je polazno, jer toliko
     stane na uobičajen ekran bez skrolovanja same stranice. */
  const [redovaPoStrani, setRedovaPoStrani] = useState(15);
  const getId = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;

  const Add2HoursDate = (input) => {
    const base = new Date(input);
    const plus2h = new Date(base.getTime() + 2 * 60 * 60 * 1000);

    return plus2h
  }

  useEffect(() => {

      if(!props.changeArtical) {
            const {
        klijentiOptions,
        magacinOptions,
        statusiOptions,
        tipoviOptions,
        vozilaOptions,
        vozaciOptions,
        nazivArtiklaOptions,
        jedinicaMereOptions
      } = props;
      
      setIdDispacher(props.idDispacher)
      setKlijentiOptions(klijentiOptions);
      setMagacinOptions(magacinOptions);
      setStatisiOptions(statusiOptions);
      setTipoviOptions(tipoviOptions);
      setVozilaOptions(vozilaOptions);
      setVozaciOptions(vozaciOptions || []);
      setNazivArtiklaOptions(nazivArtiklaOptions)
      setJedinicaMereOptions(jedinicaMereOptions)
      setValutaOpcije(props.valutaOptions || []);
      setZalihaOptions(props.zalihaOptions || []);
      setGumaZalihaOptions(props.gumaZalihaOptions || []);
      }

      if (props.idDispacher) {
          popuniRedove(props.idDispacher)
          }
  }, [props]);

  useEffect(() => {
    return () => {
      setIdDispacher(null);
      props.setIdReceiverDispacher(null)
      resetData();
      resetDataItems();
    };
  }, []);
    
  
  // ====== DATA =====

  const [formData, setFormData] = useState({
    // header
    Broj: "", // readonly
    id_klijent: null, // *
    napomena: "",
    datum: null,
    datumIsporuke: null,
    id_vozilo: null,
    id_vozac: null,
    VozacNaziv: "",
    statusOtpreme: null,
    tipOtpreme: null,
    Registracija: ""
  });

  /* Izvrsena otpremnica je zatvoren dokument: ni zaglavlje ni stavke se ne
     menjaju (procedura ih odbija), pa se dugmad gase. Storno ostaje.
     Mora ISPOD deklaracije formData — iznad nje je u mrtvoj zoni i ekran puca. */
  const jeIzvrsena = Number(formData.statusOtpreme) === 336;
  const jeStornirana = Number(formData.statusOtpreme) === 337;

  const [formDataItems, setFormDataItems] = useState({
    NazivArtikla: null,
    SifraStavke: null,
    JedinicaMere: null,
    kolicina: null,
    cena: null,
    id_magacin: null,
    SerBroj: null,
    Kilometraza: null,
    DOT: null,
  });

  // Articles filtered by stock availability
  const filteredArtiklaOptions = React.useMemo(() => {
    if (filterGuma === false) {
      const withStock = new Set(zalihaOptions.map(z => z.id_artikal));
      return nazivArtiklaOptions.filter(a => !a.Guma && withStock.has(a.value));
    }
    if (filterGuma === true) {
      const withGuma = new Set(gumaZalihaOptions.map(g => g.id_artikal));
      return nazivArtiklaOptions.filter(a => a.Guma && withGuma.has(a.value));
    }
    return nazivArtiklaOptions;
  }, [filterGuma, nazivArtiklaOptions, zalihaOptions, gumaZalihaOptions]);

  // Warehouses filtered by selected article's stock locations
  const filteredMagacinOptions = React.useMemo(() => {
    if (!formDataItems.NazivArtikla) return magacinOptions;
    const lookup = filterGuma === true ? gumaZalihaOptions : zalihaOptions;
    const validIds = new Set(
      lookup.filter(z => z.id_artikal === formDataItems.NazivArtikla).map(z => z.id_magacin)
    );
    if (formDataItems.id_magacin) validIds.add(formDataItems.id_magacin);
    if (validIds.size === 0) return magacinOptions;
    return magacinOptions.filter(m => validIds.has(m.value));
  }, [formDataItems.NazivArtikla, formDataItems.id_magacin, filterGuma, magacinOptions, zalihaOptions, gumaZalihaOptions]);

  // Serial numbers available in cart — excludes already-added tires
  const availableSerBroj = React.useMemo(() => {
    const inCartIds = new Set(gumaCart.map(g => g.id_gume));
    return serBrojOptions
      .filter(g => !inCartIds.has(g.id))
      .map(g => ({ value: g.id, label: g.SerBroj + (g.DOT ? ' — DOT ' + g.DOT : '') }));
  }, [serBrojOptions, gumaCart]);

  useEffect(() => {
    if (filterGuma !== true || !formDataItems.NazivArtikla || !formDataItems.id_magacin) {
      setSerBrojOptions([]);
      setSelectedGumaId(null);
      return;
    }
    setSelectedGumaId(null);
    fetch(process.env.REACT_APP_BACKEND_URL + '/warehouse/GetGumaByMagacin', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ id_magacin: formDataItems.id_magacin, id_artikal: formDataItems.NazivArtikla }),
    })
      .then(handleErrors)
      .then(data => setSerBrojOptions(Array.isArray(data) ? data : []))
      .catch(() => setSerBrojOptions([]));
  }, [filterGuma, formDataItems.NazivArtikla, formDataItems.id_magacin]); // eslint-disable-line

  /* Vrednost stavki racuna baza (Kolicina * Cena); ovde se samo sabira ono
     sto je u tabeli, da zbir i pojedinacni redovi ne mogu da se raziđu.
     Sabira se PO VALUTI — RSD i EUR nisu isti novac. */
  const ukupnoPoValuti = React.useMemo(() => {
    const zbir = {};
    (tableData || []).forEach(r => {
      const v = r.Valuta || '';
      zbir[v] = (zbir[v] || 0) + (Number(r.Vrednost) || 0);
    });
    return Object.entries(zbir).filter(([, iznos]) => iznos > 0);
  }, [tableData]);

  /* Valuta cene izabranog artikla — prikazuje se uz polje, ne menja se ovde:
     valuta je svojstvo cene artikla (sifarnik), ne pojedinacne otpreme. */
  const valutaArtikla = React.useMemo(() => {
    const artikl = nazivArtiklaOptions.find(x => x.value === formDataItems.NazivArtikla);
    const id = artikl?.Valuta;
    return valutaOznaka(id);
  }, [formDataItems.NazivArtikla, nazivArtiklaOptions, valutaOpcije]); // eslint-disable-line

  /* Stanje izabranog artikla u izabranom magacinu — iz istog spiska zaliha
     koji puni i padajuce izbore, pa prikaz i ponuda ne mogu da se raziđu. */
  const stanjeNaStanju = React.useMemo(() => {
    const artikal = formDataItems.NazivArtikla;
    const magacin = formDataItems.id_magacin;
    if (!artikal || !magacin) return null;

    const spisak = filterGuma === true ? gumaZalihaOptions : zalihaOptions;
    const red = spisak.find(z => z.id_artikal === artikal && z.id_magacin === magacin);
    /* Spisak nosi samo zalihe vece od nule — kad reda nema, na stanju je 0. */
    return red ? Number(red.kolicina) || 0 : 0;
  }, [formDataItems.NazivArtikla, formDataItems.id_magacin, filterGuma, zalihaOptions, gumaZalihaOptions]);

  const jedinicaMereNaziv = React.useMemo(
    () => jedinicaMereOptions.find(j => j.value === formDataItems.JedinicaMere)?.label || '',
    [formDataItems.JedinicaMere, jedinicaMereOptions]);

  const popuniStavkeItems = (apiData) => {
    const row = apiData.StavkeDB[0];
    if (row.SerBroj || row.Kilometraza) setFilterGuma(true);
    setFormDataItems({
      SifraStavke: row.NazivArtikla != null ? Number(row.NazivArtikla) : null,
      JedinicaMere: row.JedinicaMere != null ? Number(row.JedinicaMere) : null,
      kolicina: row.kolicina || null,
      /* Cena sa stavke je snimak u trenutku otpreme — ne cita se iz artikla. */
      cena: row.cena != null ? Number(row.cena) : null,
      id_magacin: row.id_magacin != null ? Number(row.id_magacin) : null,
      NazivArtikla: row.NazivArtikla != null ? Number(row.NazivArtikla) : null,
      SerBroj: row.SerBroj || null,
      Kilometraza: row.Kilometraza || null,
      DOT: row.DOT || null,
    });
  }
      
  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  const handleStampaj = () => {
     if(idDispacher) {
              let requestOptions = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token,
              },
              body: JSON.stringify({
                id: idDispacher,
                step: 'OTPREMNICA'
              }),
            };
            
            fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/PrintReceiverDispacher", requestOptions)
              .then(handleErrors)
              .then((data) => {
    
                if(data){
                  handlePrintReceiverDispacher(data, 'OTPREMNICA')
                } 
        
              })
              .catch((error) => {
                error.json().then((errorMessage) => {
                  toast.current.show({
                    severity: "error",
                    summary: "Error",
                    detail: errorMessage.message,
                    life: 3000,
                  });
                  console.log(errorMessage);
                });
              });
            } else {
               toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Niste izabrali otpremnicu kako bi je štampali!",
                    life: 3000,
                  });
            }
  }

  const handleStorno = () => {
            confirmDialog({
                  message: `Jel ste sigurni da želite pasivizirati izabranu otpremnicu?`,
                  acceptLabel: "Da",
                  rejectLabel: "Ne",
                  icon: "pi pi-info-circle",
                  acceptClassName: "p-button-danger",
                  accept: acceptDelete,
                  reject: rejectDelete,
                });

  };

    /* Izvrsenje: potvrda da je roba otisla. Posle toga dokument je zatvoren,
       pa se trazi potvrda — povratka nema osim preko storna. */
    const handleIzvrsi = () => {
        if (!idDispacher) {
            toast.current.show({
                severity: "warn", summary: t("common.upozorenje"),
                detail: t("magacin.fakturaIzaberiOtpremnicu"), life: 3000,
            });
            return;
        }

        confirmDialog({
            message: t("magacin.izvrsiPotvrda"),
            acceptLabel: t("common.da"),
            rejectLabel: t("common.ne"),
            icon: "pi pi-info-circle",
            accept: async () => {
                try {
                    const odgovor = await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/ExecuteDispacher", {
                        method: "POST",
                        headers: { "Content-Type": "application/json", Authorization: "Bearer " + auth.token },
                        body: JSON.stringify({ id: idDispacher }),
                    });
                    const podaci = await odgovor.json();
                    const poruka = Array.isArray(podaci) ? podaci[0]?.message : podaci?.message;
                    const uspeh = Array.isArray(podaci) && podaci[0]?.ID != null;

                    toast.current.show({
                        severity: uspeh ? "success" : "warn",
                        summary: poruka || t("fakture.podaciNisuStigli"),
                        life: 4000,
                    });

                    if (uspeh) popuniRedove(idDispacher);
                } catch (e) {
                    toast.current.show({ severity: "error", summary: "Error", detail: String(e?.message || e), life: 4000 });
                }
            },
        });
    };

    /* Fakturisanje otpremnice — isti put kao sa radnog naloga („Fakturiši"):
       ne pravi se faktura odavde, nego se otvara ekran izlaznih faktura i nosi
       mu se id otpremnice. Tamo procedura vrati zaglavlje i stavke, forma se
       popuni (grupa „Faktura magacin"), a operater proveri i sačuva. */
    const handleFakturisanje = () => {
        if (!idDispacher) {
            toast.current.show({
                severity: "warn", summary: t("common.upozorenje"),
                detail: t("magacin.fakturaIzaberiOtpremnicu"), life: 3000,
            });
            return;
        }

        if (!formData.id_klijent) {
            toast.current.show({
                severity: "warn", summary: t("common.upozorenje"),
                detail: t("magacin.fakturaBezKlijenta"), life: 4000,
            });
            return;
        }

        if (!tableData || tableData.length === 0) {
            toast.current.show({
                severity: "warn", summary: t("common.upozorenje"),
                detail: t("magacin.fakturaBezStavki"), life: 4000,
            });
            return;
        }

        confirmDialog({
            message: t("magacin.fakturaPotvrda"),
            acceptLabel: t("common.da"),
            rejectLabel: t("common.ne"),
            icon: "pi pi-info-circle",
            accept: () => history.push({
                pathname: "/fakture/izlazne_fakture/",
                state: { idOtpremnica: idDispacher },
            }),
        });
    };

 const acceptDelete = async () => {

    if (idDispacher) {
      let requestOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
        body: JSON.stringify({
          id: idDispacher
        }),
      };

      await fetch(
        process.env.REACT_APP_BACKEND_URL + "/warehouse/DeleteDispacher",
        requestOptions
      )
        .then(handleErrors)
        .then((data) => {

              if(data.message && data.message != 'Uspešno pasiviziranje otpremnice!'){
                  toast.current.show({
                  severity: "warn",
                  summary: data.message,
                  life: 3000,
                  });
                return
              }

          setIdDispacher(null);
          props.setIdReceiverDispatcher(null)
          setIdItem(null)
          setIzabran(null)
          setPopuni(null);
          resetData();
          resetDataItems();

          toast.current.show({
            severity: "success",
            summary: "Uspešno pasiviziranje podataka otpremnice!",
            life: 3000,
          });
        })
        .catch((error) => {
          error.json().then((errorMessage) => {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: errorMessage.message,
              life: 3000,
            });
            console.log(errorMessage);
          });
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail: "Niste izabrali otpremnicu za brisanje!",
        life: 3000,
      });
    }
  };

  const rejectDelete = () => {
    console.log("Odbijeno brisanje otpremnice!");
  };

  const invalidControl = (data) => {
    if (!formSubmitted) return false;

    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

    const invalidControlItems = (data) => {
    if (!formSubmittedItems) return false;

    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

  const addDays = (date, days) => {
    if (!date || days === null || days === undefined) return null;
    const d = date instanceof Date ? new Date(date) : new Date(date);
    if (isNaN(d.getTime())) return null;
    const n = Number(days);
    if (Number.isNaN(n)) return null;
    d.setDate(d.getDate() + n);
    return d;
  };

  const resetDataItems = () => {
    setFormDataItems({
      NazivArtikla: null,
      SifraStavke: '',
      JedinicaMere: null,
      kolicina: null,
      cena: null,
      id_magacin: null,
      SerBroj: null,
      Kilometraza: null,
      DOT: null,
    });
  }

  const resetData = () => {
    setFormData({
      Broj: "", // readonly
      id_klijent: null, // *
      napomena: "",
      datum: null,
      datumIsporuke: null,
      id_vozilo: null,
      id_vozac: null,
      VozacNaziv: "",
      statusOtpreme: null,
      tipOtpreme: null,
      Registracija: ""
  });
  setFakturaInfo(null);
  }

  const handleChange = (e) => {
    const { name, value } = e.target || e;


if (name in formData) {

    if(name === 'Registracija'){
        setFormData((prev) => {
      const next = { ...prev, [name]: value.toUpperCase() };

      return next;
    });
    return
    }
    if(name === 'tipOtpreme'){
      /* Vozač se vodi u dva polja; pri promeni tipa ono koje vise ne vazi se prazni,
         da uz internu otpremnicu ne ostane zapisan tudji vozac (ili obrnuto). */
      setFormData((prev) => (value === 338
        ? { ...prev, VozacNaziv: '' }
        : { ...prev, id_vozac: null }));
      if(value == 338){
        if(formData.id_klijent){
          setFormData((prev) => {
            const next = { ...prev, ['id_klijent']: null };
            return next;
          });
        }
        if(formData.Registracija !== ''){
          setFormData((prev) => {
            const next = { ...prev, ['Registracija']: '' };
            return next;
          });
        }
      } else {
          if(formData.id_vozilo){
          setFormData((prev) => {
            const next = { ...prev, ['id_vozilo']: null };
            return next;
          });
        }
      }
    }
    setFormData((prev) => {
      const next = { ...prev, [name]: value };

      return next;
    });
  }
  if (name in formDataItems) {
      if (name === "SerBroj") {
        const cleaned = value ? value.toString().toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 20) : null;
        setFormDataItems(prev => ({ ...prev, SerBroj: cleaned }));
        return;
      }
      if(name === "NazivArtikla") {
        let artikl = nazivArtiklaOptions.find(x => x.value === value)

        /* Magacin se bira sam kad artikal ima zalihu na jednom jedinom mestu.
           Gleda se isti spisak koji puni i padajuci izbor magacina, pa se ne
           moze desiti da se predlozi magacin koji u izboru ne postoji. */
        const zalihe = filterGuma === true ? gumaZalihaOptions : zalihaOptions;
        const magacini = [...new Set(
          zalihe.filter(z => z.id_artikal === value).map(z => z.id_magacin)
        )].filter(id => magacinOptions.some(m => m.value === id));

        if (magacini.length === 1) {
          setFormDataItems(prev => ({ ...prev, id_magacin: magacini[0] }));
        } else if (!magacini.includes(formDataItems.id_magacin)) {
          /* Stari izbor ne vazi za novi artikal — brise se, da ne ostane
             magacin u kom tog artikla nema. */
          setFormDataItems(prev => ({ ...prev, id_magacin: null }));
        }

        if(artikl) {
            setFormDataItems(prev => ({ ...prev, SifraStavke: value}));
            setFormDataItems(prev => ({ ...prev, JedinicaMere: artikl.JedinicaMere}));
            /* Predlog cene: ono sto artikal nosi. Operater je prepravi ako je
               dogovorena druga — tada se menja i cenovnik artikla. */
            setFormDataItems(prev => ({ ...prev, cena: artikl.Cena != null ? Number(artikl.Cena) : null}));
        }
        if(!value){
            setFormDataItems(prev => ({ ...prev, SifraStavke: ''}));
            setFormDataItems(prev => ({ ...prev, JedinicaMere: null}));
            setFormDataItems(prev => ({ ...prev, cena: null}));
        }
      }
      setFormDataItems(prev => ({ ...prev, [name]: value}));
  }

  };

  const handleFormSubmit = (e) => {
    e.preventDefault();


    setFormSubmitted(true);

    if (formRef.current && !formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      return;
    }

    confirmDialog({
      message: "Jel ste sigurni da želite sačuvati prijemnicu?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: acceptSave,
    });
  };

  const popuniStavke = (apiData) => {

    setFormData({
        Broj: apiData[0].Broj || '',
        id_klijent: apiData[0].id_klijent || null,
        napomena: apiData[0].napomena || '',
        datum: apiData[0].datum ? new Date(apiData[0].datum) : null,
        datumIsporuke: apiData[0].datumIsporuke ? new Date(apiData[0].datumIsporuke) : null,
        id_vozilo: apiData[0].id_vozilo || null,
        id_vozac: apiData[0].id_vozac || null,
        VozacNaziv: apiData[0].VozacNaziv || "",
        statusOtpreme: apiData[0].statusOtpreme || null,
        tipOtpreme: apiData[0].tipOtpreme || null,
        Registracija: apiData[0].Registracija || ''
    });

    setFakturaInfo(apiData[0].id_faktura ? {
        id: apiData[0].id_faktura,
        broj: apiData[0].FakturaBroj,
        status: apiData[0].FakturaStatus,
    } : null);
}

const handleNew = () => {
  resetData()
  resetDataItems()
  props.setIdReceiverDispacher(null)
  setIdDispacher(null)
  setIzabran(false)
  setTableData([])
}

  const popuniRedove = async (id) => {
      if(id){
             setPopuni(true);
             setIzabran(true)
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/FillInDispacherData", requestOptions)
                            .then(handleErrors)
                            .then(async (data) => {

                              

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                popuniStavke(data)
                                const parsedData = JSON.parse(data[0].Stavke);

                            if (parsedData && parsedData.length > 0) {

                                setTableData(parsedData)

                              const columns = Object.keys(parsedData[0])
                                .filter(key => !['ID'].includes(key))
                                .map(key => ({
                                label: key,
                                value: key
                                }));


                                setAllColumns(columns);

                                setSelectedColumns(columns.slice(0, 12).map(col => col.value));
                                } else {
                                  setTableData([]);
                                  setAllColumns([]);
                                  setSelectedColumns([]);
                                }
                            
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                }
    }


  const acceptSave = async () => {

    try {

            const payload = {
                        ...formData,
                        datum: toUtcIso(formData.datum),
                        datumIsporuke: toUtcIso(formData.datumIsporuke)
                        };

                if(props.idDispacher || izabran){
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: props.idDispacher ? props.idDispacher : idDispacher,
                                formData: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/UpdateDispacher", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                               if(data[0].message && data[0].message != 'Nema izmena u podacima otpremnice.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima otpremnice.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                                } else {
  
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka otpremnice!",
                                life: 3000,
                                });
                                }
                                setFormSubmitted(false)
                                popuniRedove(idDispacher)
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
           
            } else {
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                formData: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/InsertDispacher", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                                setFormSubmitted(false)
                                resetData()
                                popuniRedove(data?.id)
                                setIdDispacher(data?.id)

                               toast.current.show({
                                severity: "success",
                                summary: "Uspešan unos podataka otpremnice!",
                                life: 3000,
                                });
                              
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
            }
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Greška",
        detail: "Neuspešno čuvanje.",
        life: 3000,
      });
    }
  };

  const openModalItems = () => {
    resetDataItems();
    setGumaCart([]);
    setSelectedGumaId(null);
    setConfirmVisible(true);
  }

  const openModalArticles = () => {
    resetDataItems();
    setConfirmVisibleArticles(true);
    props.setChangeArtical(true);
  }

      const header = (
          <div className="export-buttons fakture-stavke-header">
              <Button type="button" style={{marginLeft:'1%'}} icon="pi pi-plus" severity="info" onClick={openModalItems} data-pr-tooltip="Nova stavka" />
                            <div style={{marginBottom: '5px', display:'flex', justifyContent:'right', maxWidth:'50%'}}>
                                              <input
                                                type="search"
                                                onInput={(e) => setGlobalFilter(e.target.value.replace(/\s+/g, ' ').trimStart())}
                                                placeholder={t('nova.phPretraga')}
                                                style={{width:'100%'}}
                                                className="p-inputtext p-component"
                                              /></div>
          </div>
      );

    const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };


    const chooseItem = async (rowData) => {    
      const id = getId(rowData);
        console.log(id)
  
      setSelectedRowId((prev) => {
        const next = String(prev) === String(id) ? null : String(id);
  
      return next;
    });
    
    setIdItem(id)

    }

    useEffect(()=> {

      if (idItem) {
          let requestOptions = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + auth.token,
                },
                body: JSON.stringify({
                  id: idItem
                }),
              };
              
              fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/GetItemDataDispacher", requestOptions)
                .then(handleErrors)
                .then((data) => {

                                const preparedData = {
                                    StavkeDB: data
                                }

                                if(data.message){  
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                popuniStavkeItems(preparedData)

                    setConfirmVisible(true)
                })
                .catch((error) => {
                  error.json().then((errorMessage) => {
                    toast.current.show({
                      severity: "error",
                      summary: "Error",
                      detail: errorMessage.message,
                      life: 3000,
                    });
                    console.log(errorMessage);
                  });
                });
          }

    },[idItem])

     const previewBodyTemplate = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
  
      const selected = isSelected(rowData);
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseItem(rowData)}
                tooltip="Izaberi stavku otpremnice za dalji rad"
                tooltipOptions={{ position: 'top' }}
              />
            
        </div>
      );
    };

  const saveItems = (x) => {

    confirmDialog({
      message: "Jel ste sigurni da želite sačuvati stavku otpremnice?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptSaveItems(x),
    });
  };

  const acceptSaveItems = async (x) => {

    try {

            if(idItem){
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idItem,
                                formDataItems
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/UpdateDispacherItem", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                               if(data[0].message && data[0].message != 'Nema izmena u podacima stavke.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima stavke.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                                } else {
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka stavke!",
                                life: 3000,
                                });
                                resetDataItems()
                                setIdItem(null)
                                setIzabran(false)
                                setSelectedRowId(null)
                                if(x){
                                  setConfirmVisible(false)
                                      if (props.idDispacher || idDispacher) {
                                            popuniRedove(props.idDispacher || idDispacher)
                                          }
                                }
                                setFormSubmittedItems(false)
                                }  
                               
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
           
            } else {
                if(idDispacher) {
                  let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idDispacher,
                                formDataItems
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/InsertDispacherItem", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                                setIdItem(null)
                                setIzabran(false)
                                setSelectedRowId(null)
                                if(x){
                                  setConfirmVisible(false)
                                  if (idDispacher) {
                                       popuniRedove(idDispacher)
                                      }
                                }
                                resetDataItems();
                                setFormSubmittedItems(false)

                               toast.current.show({
                                severity: "success",
                                summary: "Uspešan unos podataka stavke otpremnice!",
                                life: 3000,
                                });

                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Nije mogući unos stavke, nije uspešno vezana za otpremnicu!",
                    life: 3000,
                  });
                }
                          
            }
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Greška",
        detail: "Neuspešno čuvanje stavke.",
        life: 3000,
      });
    }
  };

  const handleFormRemoveItems = () => {
    confirmDialog({
      message: "Jel ste sigurni da želite pasivizirati stavku otpremnice?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: acceptRemoveItems,
    });
  }

  const acceptRemoveItems = async () => {

     if(idItem){
                          let requestOptions = {
                            method: "DELETE",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idItem
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/DeleteDispacherItem", requestOptions)
                            .then(handleErrors)
                            .then(async (data) => {

                               if(data.message){
                                    toast.current.show({
                                    severity: "warn",
                                    summary: "Upozorenje!",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }

                                const serBrojToRevert = formDataItems.SerBroj;
                                resetDataItems()
                                setIdItem(null)
                                setIzabran(false)
                                setSelectedRowId(null)
                                setFormSubmittedItems(false)
                                if(props.idDispacher || idDispacher){
                                  await popuniRedove(props.idDispacher || idDispacher)
                                }
                                setConfirmVisible(false)
                                if (serBrojToRevert) await revertGuma(serBrojToRevert);
                                toast.current.show({
                                    severity: "success",
                                    summary: "Uspešno!",
                                    detail: "Uspešno ste pasivizirali stavku otpremnice!",
                                    life: 3000,
                                    });
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
           
            } else{ 
                  toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Nije obrisana stavka otpremnice, nije uspešno vezana za otpremnicu!",
                    life: 3000,
                  });
            }

  }

  const handleScan = (code) => {
    setScannedCode(code);
    fetch(process.env.REACT_APP_BACKEND_URL + '/warehouse/GetGumaBySerBroj', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ serBroj: code }),
    })
      .then(handleErrors)
      .then(data => {
        const found = Array.isArray(data) && data.length > 0 ? data[0] : null;
        if (!found) {
          toast.current.show({ severity: 'warn', summary: 'Guma nije pronađena!', detail: `Ne postoji guma "${code}" na lageru.`, life: 5000 });
          setScannerKey(k => k + 1);
          return;
        }
        if (found.id_magacin == null) {
          let detail;
          if (found.VoziloRegistracija) {
            detail = `Guma se nalazi na vozilu ${found.VoziloRegistracija}, azurirano ${found.Azurirano || ''}`;
          } else if (found.KlijentNaziv) {
            detail = `Guma se nalazi kod klijenta ${found.KlijentNaziv} sa registracijom ${found.KlijentRegistracija || '-'}, azurirano ${found.Azurirano || ''}`;
          } else {
            detail = `Guma nije u magacinu, azurirano ${found.Azurirano || ''}`;
          }
          toast.current.show({ severity: 'warn', summary: 'Guma nije u magacinu!', detail, life: 6000 });
          setScannerKey(k => k + 1);
          return;
        }
        setGumaExisting(found);
        setPersistMagacin(found.id_magacin);
        setGumaDijalogVisible(true);
      })
      .catch(() => {
        toast.current.show({ severity: 'error', summary: 'Greška', detail: 'Nije moguće proveriti gumu.', life: 3000 });
        setScannerKey(k => k + 1);
      });
  };

  const handleGumaDijalogConfirm = () => {
    setGumaDijalogVisible(false);
    setScannerKey(k => k + 1);
    if (!gumaExisting) return;
    if (gumaCart.some(g => g.id_gume === gumaExisting.id)) {
      toast.current.show({ severity: 'warn', summary: 'Guma već u listi!', detail: gumaExisting.SerBroj, life: 3000 });
      return;
    }
    const artikl = nazivArtiklaOptions.find(a => a.value === gumaExisting.id_artikal);
    setGumaCart(prev => [...prev, {
      id_gume: gumaExisting.id,
      NazivArtikla: artikl?.label || gumaExisting.NazivArtikla || '',
      DOT: gumaExisting.DOT,
      SerBroj: gumaExisting.SerBroj,
      Kilometraza: gumaExisting.Kilometraza ?? 0,
      SifraStavke: gumaExisting.id_artikal,
      JedinicaMere: artikl?.JedinicaMere ?? null,
      id_magacin: gumaExisting.id_magacin,
    }]);
    setFilterGuma(true);
  };

  const saveGumaItemOtpremnica = async (itemData) => {
    if (!idDispacher) {
      toast.current.show({ severity: 'warn', summary: 'Nije moguće uneti stavku bez otvorene otpremnice!', life: 3000 });
      return;
    }
    try {
      const dispRes = await fetch(process.env.REACT_APP_BACKEND_URL + '/warehouse/InsertDispacherItem', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
        body: JSON.stringify({ id: idDispacher, formDataItems: itemData }),
      }).then(handleErrors);

      if (dispRes?.message) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: dispRes.message, life: 3000 });
        return;
      }

      await fetch(process.env.REACT_APP_BACKEND_URL + '/warehouse/SaveGumaPrijemnica', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
        body: JSON.stringify({
          serBroj: itemData.SerBroj,
          id_artikal: itemData.SifraStavke,
          kilometraza: itemData.Kilometraza ?? 0,
          dot: itemData.DOT ?? null,
          id_magacin: null,
          id_vozilo: formData.id_vozilo ?? null,
          id_vozac: formData.id_vozac ?? null,
          VozacNaziv: formData.VozacNaziv || null,
          id_klijent: formData.id_klijent ?? null,
          registracija: formData.id_klijent ? (formData.Registracija || null) : null,
        }),
      }).then(handleErrors);

      toast.current.show({ severity: 'success', summary: 'Guma je dodata u otpremnicu!', life: 3000 });
      popuniRedove(idDispacher);
    } catch (err) {
      err?.json?.().then(e => toast.current.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 }));
    }
  };

  const revertGuma = async (serBroj) => {
    if (!serBroj) return;
    try {
      await fetch(process.env.REACT_APP_BACKEND_URL + '/warehouse/RevertGumaPrijemnica', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
        body: JSON.stringify({ serBroj }),
      }).then(handleErrors);
    } catch (err) {
      err?.json?.().then(e => toast.current.show({ severity: 'error', summary: 'Greška pri vraćanju gume', detail: e.message, life: 3000 }));
    }
  };

  const addGumaToCart = () => {
    if (!selectedGumaId) {
      toast.current.show({ severity: 'warn', summary: 'Izaberite serijski broj!', life: 3000 });
      return;
    }
    const guma = serBrojOptions.find(g => g.id === selectedGumaId);
    if (!guma) return;
    const artikl = nazivArtiklaOptions.find(a => a.value === formDataItems.NazivArtikla);
    setGumaCart(prev => [...prev, {
      id_gume: guma.id,
      NazivArtikla: artikl?.label || guma.NazivArtikla || '',
      DOT: guma.DOT,
      SerBroj: guma.SerBroj,
      Kilometraza: guma.Kilometraza ?? 0,
      SifraStavke: formDataItems.NazivArtikla,
      JedinicaMere: guma.JedinicaMere,
      id_magacin: formDataItems.id_magacin,
    }]);
    setSelectedGumaId(null);
  };

  const acceptSaveGumaCart = async (closeAfter) => {
    if (!idDispacher) {
      toast.current.show({ severity: 'warn', summary: 'Sačuvajte otpremnicu pre unosa stavki!', life: 3000 });
      return;
    }
    if (gumaCart.length === 0) {
      toast.current.show({ severity: 'warn', summary: 'Dodajte bar jednu gumu u listu!', life: 3000 });
      return;
    }
    let errors = 0;
    for (const guma of gumaCart) {
      try {
        const dispItems = {
          NazivArtikla: guma.SifraStavke,
          SifraStavke: guma.SifraStavke,
          JedinicaMere: guma.JedinicaMere,
          kolicina: 1,
          id_magacin: guma.id_magacin,
          SerBroj: guma.SerBroj,
          DOT: guma.DOT,
          Kilometraza: guma.Kilometraza,
        };
        const dispRes = await fetch(process.env.REACT_APP_BACKEND_URL + '/warehouse/InsertDispacherItem', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
          body: JSON.stringify({ id: idDispacher, formDataItems: dispItems }),
        }).then(handleErrors);
        if (dispRes?.message) {
          toast.current.show({ severity: 'error', summary: `Greška: ${guma.SerBroj}`, detail: dispRes.message, life: 4000 });
          errors++;
          continue;
        }
        await fetch(process.env.REACT_APP_BACKEND_URL + '/warehouse/SaveGumaPrijemnica', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
          body: JSON.stringify({
            serBroj: guma.SerBroj,
            id_artikal: guma.SifraStavke,
            kilometraza: guma.Kilometraza ?? 0,
            dot: guma.DOT ?? null,
            id_magacin: null,
            id_vozilo: formData.id_vozilo ?? null,
            id_vozac: formData.id_vozac ?? null,
            VozacNaziv: formData.VozacNaziv || null,
            id_klijent: formData.id_klijent ?? null,
            registracija: formData.id_klijent ? (formData.Registracija || null) : null,
          }),
        }).then(handleErrors);
      } catch (err) {
        errors++;
        err?.json?.().then(e => toast.current.show({ severity: 'error', summary: `Greška: ${guma.SerBroj}`, detail: e?.message, life: 4000 }));
      }
    }
    const saved = gumaCart.length - errors;
    setGumaCart([]);
    setSelectedGumaId(null);
    resetDataItems();
    if (saved > 0) {
      toast.current.show({ severity: 'success', summary: `Uspešno uneto ${saved} guma!`, life: 3000 });
    }
    popuniRedove(idDispacher);
    if (closeAfter) setConfirmVisible(false);
  };

  const handleFormSubmitItems = (x) => {
    if (filterGuma === true && !idItem) {
      acceptSaveGumaCart(x);
      return;
    }
    setFormSubmittedItems(true);
    if (formRefItems.current && !formRefItems.current.checkValidity()) {
      formRefItems.current.reportValidity();
      return;
    }
    saveItems(x);
  }

  return (
    <div className="p-fluid grid formUnosZap" style={{ maxWidth: "99%" }}>
      <Toast ref={toast} />
      <ConfirmDialog />

            <ConfirmationModalArticles                
                visible={confirmVisibleArticles}
                onHide={() => {setConfirmVisibleArticles(false); props.setChangeArtical(false);}}>
                <UnosArtiklaKonfig setChangeArtical={props.setChangeArtical}/>
            </ConfirmationModalArticles>
      
            <ConfirmationModalPrijemnicaOtpremnica
                visible={confirmVisible}
                onHide={() => {setConfirmVisible(false);setIdItem(null);setIzabran(false);setSelectedRowId(null);setFilterGuma(false);setGumaCart([]);setSelectedGumaId(null);popuniRedove(props.idDispacher ? props.idDispacher : idDispacher)}}
                onConfirmContinue={() => {handleFormSubmitItems(false)}}
                onConfirmExit={() => {handleFormSubmitItems(true)}}
                onConfirmRemove={handleFormRemoveItems}
                idItem={idItem}
            >
              <form autoComplete="off" ref={formRefItems}  style={{ display:'flex', flexWrap: 'wrap', minWidth: '100%' }}>
                  <div className="col-12" style={{display:'flex', marginBottom:'0.5rem', flexWrap:'wrap', gap:'0.5rem'}}>
                    <Button type="button" label={t('magacin.ostalo')} className=""
                      id={filterGuma === false ? 'activeButton' : undefined}
                      style={{fontSize: 'smaller', marginLeft:'0', marginTop:'0'}} onClick={() => { setFilterGuma(false); resetDataItems(); setGumaCart([]); setSelectedGumaId(null); }} />
                    <Button type="button" label={t('magacin.pneumaticiGume')} className=""
                      id={filterGuma === true ? 'activeButton' : undefined}
                      style={{fontSize: 'smaller', marginTop:'0'}} onClick={() => { setFilterGuma(true); resetDataItems(); setGumaCart([]); setSelectedGumaId(null); }} />
                    {filterGuma && (
                      <Button type="button" icon="pi pi-qrcode" title="Skeniraj barkod gume" className=""
                        style={{fontSize: 'smaller', marginLeft:'0.5rem', marginTop:'0'}}
                        severity="secondary"
                        onClick={() => { setScannerKey(k => k + 1); setScannerVisible(true); }} />
                    )}
                  </div>
                  <div className="col-6 md:col-6 stavkaPrijemFirst">
                    <label htmlFor="artikal">{t('magacin.nazivArtikla')}:</label>
                    <div style={{display:'flex'}}>
                        <CustomDropdown
                        id="NazivArtikla"
                        name="NazivArtikla"
                        optionLabel="label"
                        value={formDataItems.NazivArtikla}
                        options={filteredArtiklaOptions}
                        onChange={handleChange}
                        placeholder={t('nova.phArtikal')}
                        style={{maxWidth:'90%'}}
                      />
                      <Button type="button" style={{maxWidth:'10%', display:'flex', justifyContent:'center', alignItems:'center'}} icon="pi pi-plus" severity="info" onClick={openModalArticles} data-pr-tooltip="Novi artikl" />
                    </div>
                  </div>
                  {!filterGuma && <div className="col-6 md:col-3 stavkaPrijem">
                    <label htmlFor="SifraStavke">{t('magacin.sifraArtikla')}:</label>
                      <InputText
                        id="SifraStavke"
                        name="SifraStavke"
                        style={{minWidth: '100%'}}
                        disabled
                        value={formDataItems.SifraStavke}
                        onChange={handleChange}
                        type="number"
                      />
                  </div>}

                  {!filterGuma && <div className="col-6 md:col-6 stavkaPrijem">
                    <label htmlFor="JedinicaMere">{t('nova.jedinicaMere')}:</label>
                    <CustomDropdown
                      id="JedinicaMere"
                      name="JedinicaMere"
                      optionLabel="label"
                      disabled
                      value={formDataItems.JedinicaMere}
                      options={jedinicaMereOptions}
                      onChange={handleChange}
                      placeholder={t('nova.phJedinicu')}
                    />
                  </div>}

                  <div className="col-6 md:col-6 stavkaPrijem" style={filterGuma ? {width:'100%'} : {}}>
                    <label htmlFor="id_magacin">{t('nova.magacin')}:</label>
                    <CustomDropdown
                      id="id_magacin"
                      name="id_magacin"
                      optionLabel="label"
                      value={formDataItems.id_magacin}
                      options={filteredMagacinOptions}
                      required
                      invalid={invalidControlItems(formDataItems.id_magacin)}
                      onChange={handleChange}
                      placeholder={t('nova.phMagacin')}
                    />
                  </div>
                  {!filterGuma && <div className="col-6 md:col-3 stavkaPrijem">
                    <label htmlFor="kolicina">
                      {t('nova.kolicina')}
                      {stanjeNaStanju !== null && (
                        <span className="stanje-uz-kolicinu">
                          {' — ' + t('magacin.naStanju') + ': '}
                          {stanjeNaStanju.toLocaleString('sr-RS', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          {jedinicaMereNaziv ? ' ' + jedinicaMereNaziv : ''}
                        </span>
                      )}:
                    </label>
                    <InputNumber
                    id="kolicina"
                    name="kolicina"
                    required
                    style={{minWidth: '100%'}}
                    invalid={invalidControlItems(formDataItems.kolicina)}
                    value={formDataItems.kolicina}
                    onValueChange={handleChange}
                    min={1}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    />
                  </div>}
                  {/* Cena: forma je predlozi sa artikla. Druga cena ovde menja i
                      cenovnik artikla i ulazi u istoriju cena. */}
                  <div className="col-6 md:col-3 stavkaPrijem">
                    <label htmlFor="cena">
                      {t('magacin.cenaNeto')}{valutaArtikla ? ' (' + valutaArtikla + ')' : ''}:
                    </label>
                    <InputNumber
                      id="cena"
                      name="cena"
                      style={{minWidth: '100%'}}
                      value={formDataItems.cena}
                      onValueChange={handleChange}
                      min={0}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                    />
                  </div>
                  {filterGuma && !idItem && <>
                    <div className="col-12 stavkaPrijemFirst" style={{width:'100%'}}>
                      <label>{t('magacin.serijskiBroj')}:</label>
                      <div style={{display:'flex'}}>
                        <CustomDropdown
                          id="SerBrojDD"
                          name="SerBrojDD"
                          optionLabel="label"
                          value={selectedGumaId}
                          options={availableSerBroj}
                          onChange={e => setSelectedGumaId((e?.target ?? e)?.value ?? e?.value ?? null)}
                          placeholder={t('magacin.phSerijski')}
                          style={{maxWidth:'90%'}}
                          disabled={!formDataItems.NazivArtikla || !formDataItems.id_magacin}
                        />
                        <Button type="button"
                          style={{maxWidth:'10%', display:'flex', justifyContent:'center', alignItems:'center'}}
                          icon="pi pi-plus"
                          severity="success"
                          onClick={addGumaToCart}
                          title="Dodaj u listu"
                        />
                      </div>
                    </div>
                    {gumaCart.length > 0 && (
                      <div className="col-12" style={{marginTop:'0.5rem', overflowX:'auto'}}>
                        <table style={{width:'100%', borderCollapse:'collapse', fontSize:'0.82rem'}}>
                          <thead>
                            <tr style={{color:'#f0f0f0'}}>
                              <th style={{padding:'4px 8px', border:'1px solid #ddd', width:36, textAlign:'center'}}>Rb.</th>
                              <th style={{padding:'4px 8px', border:'1px solid #ddd'}}>Naziv + DOT</th>
                              <th style={{padding:'4px 8px', border:'1px solid #ddd'}}>Ser. broj</th>
                              <th style={{padding:'4px 8px', border:'1px solid #ddd', width:70, textAlign:'right'}}>Km</th>
                              <th style={{padding:'4px 8px', border:'1px solid #ddd', width:40}}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {gumaCart.map((g, i) => (
                              <tr key={g.id_gume ?? i} style={{background: i%2===0?'#fff':'#fafafa'}}>
                                <td style={{padding:'4px 8px', border:'1px solid #ddd', textAlign:'center'}}>{i+1}</td>
                                <td style={{padding:'4px 8px', border:'1px solid #ddd'}}>{g.NazivArtikla}{g.DOT ? ' - DOT '+g.DOT : ''}</td>
                                <td style={{padding:'4px 8px', border:'1px solid #ddd', fontFamily:'monospace', fontSize:'0.85rem'}}>{g.SerBroj}</td>
                                <td style={{padding:'4px 8px', border:'1px solid #ddd', textAlign:'right'}}>{g.Kilometraza ?? 0}</td>
                                <td style={{padding:'4px 8px', border:'1px solid #ddd', textAlign:'center'}}>
                                  <Button type="button" icon="pi pi-trash" severity="danger" text rounded
                                    onClick={() => setGumaCart(prev => prev.filter((_, idx) => idx !== i))}
                                    style={{padding:'2px', width:'24px', height:'24px'}}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </>}
                  {filterGuma && idItem && (
                    <div className="col-6 md:col-3 stavkaPrijem">
                      <label htmlFor="SerBroj">{t('magacin.serijskiBroj')}:</label>
                      <InputText
                        id="SerBroj"
                        name="SerBroj"
                        style={{minWidth: '100%'}}
                        value={formDataItems.SerBroj || ''}
                        onChange={handleChange}
                        maxLength={20}
                      />
                    </div>
                  )}
            </form>
          </ConfirmationModalPrijemnicaOtpremnica>
      {/* OPCIJE TOOLBAR */}
      <div className="col-12 novaDinarskaIzlazneHeader">
        <Button label={t('magacin.nova')} type="button" style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}} onClick={handleNew} />
        <Button label={t('nova.stampa')} type="button" style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}} onClick={handleStampaj} />
        {/* Izvršena ili fakturisana otpremnica se ne stornira — procedura to
            odbija, pa dugme ni ne stoji aktivno. */}
        <Button
          label={t('nova.storno')}
          type="button"
          className="p-button-danger"
          disabled={jeIzvrsena || jeStornirana || !!fakturaInfo}
          style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}}
          onClick={handleStorno}
        />
        {/* Prazna otpremnica nema šta da izvrši — procedura to odbija, pa dugme
            stoji ugašeno dok se ne unese bar jedna stavka. */}
        {!jeIzvrsena && !jeStornirana && (
          <Button
            label={t('magacin.izvrsi')}
            type="button"
            className="p-button-warning"
            disabled={!idDispacher || (tableData || []).length === 0}
            style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}}
            onClick={handleIzvrsi}
          />
        )}
        {/* Otpremnica koja vec ima aktivnu fakturu ne fakturise se ponovo: dugme
            je zakljucano i crveno, a oznaka pored njega kaze koja je faktura.
            Stornirana faktura ne racuna se — procedura vraca samo aktivnu. */}
        <Button
          label={t('magacin.unesiFakturu')}
          type="button"
          className={fakturaInfo ? 'p-button-danger' : 'p-button-success'}
          disabled={!!fakturaInfo}
          style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}}
          onClick={handleFakturisanje}
        />
        {fakturaInfo && (
          <Tag
            severity="danger"
            value={t('magacin.fakturisana') + ': ' + (fakturaInfo.broj || '')}
          />
        )}
                          
      </div>
      <form
        autoComplete="off"
        ref={formRef}
        className="col-12 novaDinarskaIzlazneForm"
      >
          <div className="gridFakture">
            <div className="col-6 md:col-3">
              <label htmlFor="Broj">{t('nova.broj')}:</label>
              <InputText
                id="Broj"
                name="Broj"
                readOnly
                style={{ backgroundColor: "#efefef" }}
                value={formData.Broj}
              />
            </div>

            <div className="col-6 md:col-3">
              <label htmlFor="datum">{t('nova.datum')}:</label>
              <Calendar
                id="datum"
                name="datum"
                value={formData.datum}
                onChange={handleChange}
                required
                invalid={invalidControl(formData.datum)}
                showIcon
                mask="99.99.9999"
                dateFormat="dd.mm.yy"
              />
            </div>
            <div className="col-6 md:col-3">
              <label htmlFor="datumIsporuke">{t('magacin.datumIsporuke')}:</label>
              <Calendar
                id="datumIsporuke"
                name="datumIsporuke"
                value={formData.datumIsporuke}
                onChange={handleChange}
                showIcon
                mask="99.99.9999"
                dateFormat="dd.mm.yy"
              />
            </div>
            <div className="col-6 md:col-6">
              <label htmlFor="statusOtpreme">{t('nova.status')}:</label>
              <CustomDropdown
                id="statusOtpreme"
                name="statusOtpreme"
                disabled
                optionLabel="label"
                value={formData.statusOtpreme}
                options={statisiOptions || []}
                onChange={handleChange}
              />
            </div>
            <div className="col-6 md:col-6">
              <label htmlFor="tipOtpreme">{t('nova.tip')}:</label>
              <CustomDropdown
                id="tipOtpreme"
                name="tipOtpreme"
                optionLabel="label"
                required
                invalid={invalidControl(formData.tipOtpreme)}
                value={formData.tipOtpreme}
                options={tipoviOptions || []}
                onChange={handleChange}
              />
            </div>
            <div className="col-6 md:col-6">
              <label htmlFor="id_klijent">{t('nova.klijent')}:</label>
              <CustomDropdown
                id="id_klijent"
                name="id_klijent"
                optionLabel="label"
                disabled={!formData.tipOtpreme || formData.tipOtpreme === 338}
                required={!formData.tipOtpreme || formData.tipOtpreme !== 338 ? true : null}
                invalid={!formData.tipOtpreme || formData.tipOtpreme !== 338 ? invalidControl(formData.id_klijent) : null}
                value={formData.id_klijent}
                options={klijentiOptions || []}
                onChange={handleChange}
                placeholder={t('nova.phKlijenta')}
              />
            </div>
            <div className="col-6 md:col-6">
              <label htmlFor="id_vozilo">{t('nova.vozilo')}:</label>
              <CustomDropdown
                id="id_vozilo"
                name="id_vozilo"
                optionLabel="label"
                disabled={!formData.tipOtpreme || formData.tipOtpreme !== 338 ? true : null}
                value={formData.id_vozilo}
                options={vozilaOptions || []}
                onChange={handleChange}
              />
            </div>
            {/* Vozač — polje postoji UVEK, ali menja i oblik i obaveznost po tipu:

                  INTERNO (338)  → padajući spisak naših vozača, OBAVEZNO
                  ostali tipovi  → slobodan tekst (tuđi vozač), opciono

                Isti obrazac koji ova forma već koristi za vozilo: `id_vozilo` za naše,
                `Registracija` kao tekst za tuđe. Jedno polje koje bi primalo i šifru i
                ime značilo bi da „5" može biti i jedno i drugo. */}
            {formData.tipOtpreme === 338 ? (
              <div className="col-6 md:col-3">
                <label htmlFor="id_vozac">{t('nova.vozac')}:</label>
                {/* NIJE obavezan. Interna otprema ume da krene i bez upisanog
                    vozaca (roba ceka na utovar, vozac se zna tek ujutru), a dok
                    je polje bilo obavezno otpremnica se uopste nije mogla snimiti
                    — ni kada u spisku nema nijednog vozaca za izbor. */}
                <CustomDropdown
                  id="id_vozac"
                  name="id_vozac"
                  optionLabel="label"
                  value={formData.id_vozac}
                  options={vozaciOptions || []}
                  onChange={handleChange}
                  placeholder={t('ture.phVozaca')}
                />
              </div>
            ) : (
              <div className="col-6 md:col-3">
                <label htmlFor="VozacNaziv">{t('nova.vozacTudji')}:</label>
                <InputText
                  id="VozacNaziv"
                  name="VozacNaziv"
                  maxLength={100}
                  disabled={!formData.tipOtpreme}
                  value={formData.VozacNaziv}
                  onChange={handleChange}
                />
              </div>
            )}
            <div className="col-6 md:col-3">
              <label htmlFor="Registracija">{t('ture.registracija')}:</label>
              <InputText
                id="Registracija"
                name="Registracija"
                onChange={handleChange}
                disabled={!formData.tipOtpreme || formData.tipOtpreme === 338 ? true : null}
                value={formData.Registracija}
              />
            </div>
            <div className="col-12">
                <label htmlFor="napomena">{t('nova.napomena')}:</label>
                          <InputTextarea
                            id="napomena"
                            name="napomena"
                            value={formData.napomena}
                            onChange={handleChange}
                            rows={3}
                          />
            </div>
          </div>
      </form>
        {/* Visinu ograničava TELO tabele (scrollHeight), ne okvir — inače bi
            okvir odsekao paginator na nižem ekranu. `!important` u inline stilu
            React ionako ne primenjuje, pa margina ide kroz klasu. */}
        <div className="zaposleni_table_container tableItems stavke-okvir">
          <Toast ref={toast} />
              <Tooltip target=".export-buttons>button" position="bottom" />
              {/* Telo tabele raste sa ekranom, ali ne preko njega: na uobičajenom
                  ekranu stane petnaestak stavki, na nižem manje — i tada se skroluje
                  po stavkama, unutar tabele, a ne cela stranica. */}
              <DataTable
                paginator
                rows={redovaPoStrani}
                rowsPerPageOptions={[15, 30, 50, 100]}
                first={first}
                globalFilter={globalFilter}
                onPage={(e) => { setFirst(e.first); setRedovaPoStrani(e.rows); }}
                scrollable
                header={header}
                scrollHeight="clamp(200px, 52vh, 700px)"
                emptyMessage={t('common.noDataTable')}
                value={tableData || []}
                resizableColumns
                className="izlazneFaktureTable stavke-tabela"
                columnResizeMode="expand"
                rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
              >
                {selectedColumns.map((colKey) => {
                const colMeta = allColumns.find(col => col.value === colKey);
                return (
                  <Column
                    key={colKey}
                    field={colKey}
                    header={colMeta?.label || colKey}
                    sortable
                    body={(rowData) => {
                      if (isButtonColumn(colKey)) {
                        return previewBodyTemplate(rowData, colKey);
                      }
                      return rowData[colKey] ?? '-';
                    }}
                  />
                );
              })}
              </DataTable>
              {/* Zbir vrednosti stavki — isti brojevi koje faktura prenese.
                  Po jedan red za svaku valutu koja se pojavi. */}
              {ukupnoPoValuti.map(([valuta, iznos]) => (
                <div className="stavke-ukupno" key={valuta}>
                  <span>{t('magacin.ukupnaVrednost')}:</span>
                  <strong>{iznos.toLocaleString('sr-RS', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {valuta}</strong>
                </div>
              ))}
            </div>
      <div className="formUnosZap buttonUnosFakture">
        <button
          type="submit"
          onClick={handleFormSubmit}
          className="btn btn-success"
        >
          {props.idDispacher || idDispacher || izabran ? 'SAČUVAJ' : 'UNOS'}
        </button>
      </div>

      <BarcodeScanner
        key={scannerKey}
        visible={scannerVisible}
        onHide={() => { setScannerVisible(false); setGumaDijalogVisible(false); setPersistMagacin(null); }}
        onScan={handleScan}
      />
      <GumaScanDijalog
        visible={gumaDijalogVisible}
        onHide={() => setGumaDijalogVisible(false)}
        onConfirm={handleGumaDijalogConfirm}
        serBroj={scannedCode}
        gumaData={gumaExisting}
        magacinOptions={magacinOptions}
        nazivArtiklaOptions={nazivArtiklaOptions}
        defaultMagacin={persistMagacin}
      />
    </div>
  );
};

export default Nova_otpremnica;
